import { Component, OnInit } from '@angular/core';
import { OfbizForm,OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, BreadCrumbData, ComponentConfig,ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { FORMS } from '../forms';
import { SETTINGS as settings } from '../model';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-data-resource',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./data-resource.component.scss']
})
export class DataResourceComponent extends BaseComponentConfig implements OnInit {
  breadCrumbs:BreadCrumbData[];
  options:ConfigOptions = {
    name:"Name",
    title:"Data Resource",
    addForm:new OfbizForm({
      formName:"EditDataResource",
      entityName:"DataResource",
      formLocation:"component://content/widget/content/DataResourceForms.xml",
      target:'createDataResource',
      altTargets:this.getAltTarget("EditDataResource",FORMS),
      hasFormData:true
    }),
    findForm:new OfbizForm({
      local:true,
      viewMode:"popover",
      formAction:"find",
      formName:"FindDataResource",
      entityName:"DataResource",
      formLocation:"component://content/widget/content/DataResourceForms.xml",
      target:"listFindDataResource",
      fields:this.getFields("FindDataResource",FORMS),
    }),
    listForm:new OfbizList({
      fieldFormName:"FindDataResource",
      fieldFormLocation:"local",
      fieldFormFields:this.getFields("FindDataResource",FORMS),
      listFormName:"ListDataResource",
      entityName:"DataResource",
      listFormLocation:"component://content/widget/content/DataResourceForms.xml",
      columnFields:this.getFields("ListDataResource",FORMS),
      endPoint:"listFindDataResource",
      emptyListMessage:"",
      viewIndex:1,
      findParameters:[
        {"noConditionFind":"Y"}
      ],
      actions:{
        position:'right',
        custom:[
          {
            name:'overView',
            title:'<i class="nb-eye-outline" title="Over View"></i>'
          }
        ],
        delete:false,
      },
    }),
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Data Resources",
      label:"",
      level:1,
      selectedValue:{
          "event":"list",
          "type":"ListDataResource",
          "data":{
            "formData":{
              "formName":"ListDataResource",
              "formLocation":"component://content/widget/content/DataResourceForms.xml",
              "noConditionFind":"Y"
            },
            "endPoint":"listFindContent",
          },
      },
      addFormText:"Create New Data Resource",
      editFormText:"Update Data Resource",
    },
    settings:settings,
      summaryView:[ //Content (many), DataResourceRole (many), DataResource (one)
        {
          title:"Data Resource",
          entityName:"DataResource",
          order:1,
          type:"single",
          formName:"EditDataResource",
          formLocation:"component://content/widget/content/DataResourceForms.xml",
          fullWidth:false
        },
        {
          title:"Data Resource Roles",
          entityName:"DataResourceRole",
          order:2,
          type:"list",
          formName:"ListDataResourceRole",
          formLocation:"component://content/widget/content/DataResourceForms.xml",
          fullWidth:false
        },
        {
          title:"Data Resource and Content",
          entityName:"DataResourceContentView",
          order:3,
          type:"list",
          formName:"ListLookupDataResourceContent",
          formLocation:"component://content/widget/content/DataResourceForms.xml",
          fullWidth:true
        },
      ]
  }


  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(this.options);
    
  }

  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }


}
